'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

function useLazyRef(getValue) {
  const [value] = React.useState(getValue);
  const ref = React.useRef(value);
  return ref;
}

exports.useLazyRef = useLazyRef;
